/*
 * Cart drawer (painel flutuante translúcido) — mesmo design system do menu mobile/desktop.
 * Abre/fecha o carrinho sobre a página atual em vez de navegar para /cart.
 * O CONTEÚDO do drawer é a section "cart-drawer" (Shopify Cart AJAX API com ?sections=),
 * então toda mudança (qty, remover, quick add) recarrega apenas o HTML da section — a
 * lógica de preço/frete grátis/recomendações continua vivendo em Liquid, não duplicada em JS.
 */
(function () {
  if (window.__cartDrawerInit) return;
  window.__cartDrawerInit = true;

  var root = document.querySelector('[data-cart-drawer]');
  var scrim = document.querySelector('[data-cart-drawer-scrim]');
  var sectionRoot = document.querySelector('[data-cart-drawer-section]');
  if (!root || !sectionRoot) return;

  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var changeUrl = root.getAttribute('data-cart-change-url') || '/cart/change.js';
  var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
  var updateUrl = root.getAttribute('data-cart-update-url') || '/cart/update.js';
  var sectionId = 'cart-drawer';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var scrollY = 0;
  var lastFocused = null;
  var closeTimer = null;

  function getTrigger() {
    return document.querySelector('[data-cart-drawer-trigger]');
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (root.classList.contains('is-open')) return; /* já aberto: não relocka (salvaria scroll 0) */
    root.hidden = false;
    if (scrim) scrim.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.classList.add('is-open'); scrim.setAttribute('aria-hidden', 'false'); }
    lockScroll();
    var trig = getTrigger();
    if (trig) trig.setAttribute('aria-expanded', 'true');
    lastFocused = document.activeElement;
    var closeBtn = root.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    if (scrim) { scrim.classList.remove('is-open'); scrim.setAttribute('aria-hidden', 'true'); }
    unlockScroll();
    var trig = getTrigger();
    if (trig) trig.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && lastFocused !== document.body && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    } else if (trig) {
      trig.focus({ preventScroll: true });
    }
    closeTimer = setTimeout(function () {
      root.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 350);
  }

  function toggleDrawer() {
    if (root.classList.contains('is-open')) closeDrawer();
    else openDrawer();
  }

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-cart-drawer-trigger]');
    if (trig) {
      e.preventDefault();
      toggleDrawer();
    }
  });

  if (scrim) scrim.addEventListener('click', closeDrawer);

  // ======================================================================
  // ESTADO DO CARRINHO — fonte única de verdade
  //
  // O estado verdadeiro é o carrinho do Shopify. Toda mutação (add / change /
  // remove / quick add / "adicionar tudo") passa por ErmosCart, que:
  //   1) serializa as requisições numa fila (nenhuma resposta antiga chega depois
  //      de uma mais nova e restaura estado velho);
  //   2) pede a section "cart-drawer" NA PRÓPRIA requisição POST (renderizada
  //      depois da mutação, nunca cacheada) — 1 requisição por ação, sem GET extra;
  //   3) renderiza essa section e deriva dela TODOS os consumidores: itens,
  //      subtotal, frete, estado vazio, recomendações e o contador do header.
  // Abrir/fechar (is-open) e atualizar (aria-busy) são estados independentes:
  // uma atualização nunca toca opacity/visibility/transform do shell de vidro.
  // ======================================================================

  function updateCartCount(count) {
    var link = getTrigger();
    if (!link || typeof count !== 'number' || isNaN(count)) return;
    var sup = link.querySelector('sup');
    if (count > 0) {
      if (!sup) {
        sup = document.createElement('sup');
        link.insertBefore(sup, link.firstChild);
      }
      sup.textContent = count;
    } else if (sup) {
      sup.remove();
    }
  }

  function sectionHost(scope) {
    return scope.querySelector('#shopify-section-' + sectionId) || scope;
  }

  /* Atualiza o conteúdo do drawer a partir do HTML da section, trocando só o que mudou:
     - o topbar (botão fechar, foco) é preservado — só o texto da contagem muda;
     - imagens de itens que continuam no carrinho são reaproveitadas (sem piscar/recarregar);
     - o bloco de recomendações já carregado é reaproveitado (sem sumir/refetch);
     - o restante é trocado numa única operação síncrona (nenhum frame intermediário).
     O shell (.cart-drawer, blur, scrim, is-open, scroll lock) nunca é tocado. */
  function render(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = sectionHost(tmp);
    var host = sectionHost(sectionRoot);

    var freshTop = fresh.querySelector('.cart-drawer__topbar');
    var oldTop = host.querySelector('.cart-drawer__topbar');
    var count = freshTop ? parseInt(freshTop.getAttribute('data-cart-item-count'), 10) : NaN;

    // recomendações: reaproveita o bloco já carregado
    var oldRec = host.querySelector('[data-cart-recommend-block]');
    var newRec = fresh.querySelector('[data-cart-recommend-block]');
    var recScroll = 0;
    if (oldRec && newRec && oldRec.dataset.loaded === 'true' && !oldRec.hidden) {
      var oldTrack = oldRec.querySelector('[data-cart-carousel]');
      recScroll = oldTrack ? oldTrack.scrollLeft : 0;
      if (oldRec.getAttribute('data-url') === newRec.getAttribute('data-url')) {
        newRec.parentNode.replaceChild(oldRec, newRec);
        newRec = oldRec;
      } else {
        // semente mudou: mostra a lista atual até a nova chegar (sem esconder o bloco)
        var oldList = oldRec.querySelector('[data-cart-recommend-list]');
        var newList = newRec.querySelector('[data-cart-recommend-list]');
        if (oldList && newList) newList.innerHTML = oldList.innerHTML;
        newRec.hidden = false;
        if (oldRec.classList.contains('is-collapsed')) {
          newRec.classList.add('is-collapsed');
          var t = newRec.querySelector('[data-cart-recommend-toggle]');
          if (t) { t.setAttribute('aria-expanded', 'false'); t.setAttribute('aria-label', 'Expandir recomendações'); }
        }
      }
    }

    // itens que continuam no carrinho: reaproveita a mídia já decodificada
    Array.prototype.forEach.call(fresh.querySelectorAll('[data-cart-item]'), function (item) {
      var key = item.getAttribute('data-line-key');
      var old = key && host.querySelector('[data-cart-item][data-line-key="' + CSS.escape(key) + '"] .cart-drawer__item-image');
      var neu = item.querySelector('.cart-drawer__item-image');
      if (old && neu) neu.parentNode.replaceChild(old, neu);
    });

    var active = document.activeElement;
    var hadFocus = active && host.contains(active) && !(oldTop && oldTop.contains(active));

    if (freshTop && oldTop) {
      oldTop.setAttribute('data-cart-item-count', freshTop.getAttribute('data-cart-item-count'));
      var oldCount = oldTop.querySelector('.cart-drawer__count');
      var newCount = freshTop.querySelector('.cart-drawer__count');
      if (oldCount && newCount) oldCount.textContent = newCount.textContent;
      freshTop.remove();
      var nodes = Array.prototype.slice.call(fresh.childNodes);
      Array.prototype.slice.call(host.childNodes).forEach(function (n) {
        if (n !== oldTop) host.removeChild(n);
      });
      nodes.forEach(function (n) { host.appendChild(n); });
    } else {
      host.replaceChildren.apply(host, Array.prototype.slice.call(fresh.childNodes));
    }

    if (recScroll && newRec) {
      var track = newRec.querySelector('[data-cart-carousel]');
      if (track) track.scrollLeft = recScroll;
    }

    // o elemento focado saiu do DOM (ex.: lixeira do item removido): mantém o foco no drawer
    if (hadFocus && !document.contains(active) && root.classList.contains('is-open')) {
      var closeBtn = root.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    updateCartCount(count);
    reconcileGift();
    initRecommendations();
    initCarousel();
    document.dispatchEvent(new CustomEvent('ermos:cart:updated', { detail: { itemCount: count } }));
  }

  /* Corrige o carrinho quando sobra brinde (cliente tirou a camiseta, baixou a
     quantidade, etc). Uma mutacao por render: o proximo render chama de novo. */
  function reconcileGift() {
    var lines = Array.prototype.slice.call(root.querySelectorAll('[data-gift-line]'));
    if (!lines.length) return;
    var block = root.querySelector('[data-gift-block]');
    var allowed = block ? parseInt(block.getAttribute('data-gift-allowed'), 10) || 0 : 0;
    var total = lines.reduce(function (n, el) {
      return n + (parseInt(el.getAttribute('data-gift-qty'), 10) || 0);
    }, 0);
    var excess = total - allowed;
    if (excess <= 0) return;
    var last = lines[lines.length - 1];
    var qty = parseInt(last.getAttribute('data-gift-qty'), 10) || 0;
    changeLine(last.getAttribute('data-line-key'), Math.max(0, qty - excess));
  }

  // ---- Fila de mutações ----
  var queue = Promise.resolve();
  var pending = 0;

  function setUpdating(on) {
    if (on) root.setAttribute('aria-busy', 'true');
    else root.removeAttribute('aria-busy');
  }

  function enqueue(task) {
    pending++;
    setUpdating(true);
    var run = queue.then(task);
    queue = run.catch(function () {}).then(function () {
      pending--;
      if (!pending) setUpdating(false);
    });
    return run;
  }

  /* Uma requisição POST que muta o carrinho e devolve a section renderizada.
     Só a ÚLTIMA resposta da fila renderiza (respostas intermediárias já estariam
     superadas pela próxima mutação); o carrinho final é sempre o do Shopify. */
  function mutate(url, payload, isRefresh) {
    return enqueue(function () {
      var opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
      if (payload instanceof FormData) {
        payload.set('sections', sectionId);
        payload.set('sections_url', cartUrl);
        opts.body = payload;
      } else {
        payload.sections = sectionId;
        payload.sections_url = cartUrl;
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(payload);
      }
      return fetch(url, opts)
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            var err = new Error((res.data && (res.data.description || res.data.message)) || 'Não foi possível atualizar o carrinho.');
            err.status = res.data && res.data.status;
            throw err;
          }
          var html = res.data && res.data.sections && res.data.sections[sectionId];
          if (html && pending <= 1) render(html);
          return res.data;
        })
        .catch(function (err) {
          // se esta era a última da fila, a tela pode ter ficado num estado intermediário:
          // ressincroniza com o carrinho real (sem fechar nada, sem reload)
          if (!isRefresh && pending <= 1) refresh().catch(function () {});
          throw err;
        });
    });
  }

  /* Ressincroniza com o carrinho real sem mutar nada: /cart/update.js com updates
     vazio devolve o carrinho + section recém-renderizada (POST, nunca cacheado). */
  function refresh() {
    return mutate(updateUrl, { updates: {} }, true);
  }

  window.ErmosCart = {
    /* payload: FormData de um form de produto OU array [{id, quantity}] */
    add: function (payload, options) {
      var body = payload instanceof FormData ? payload : { items: payload };
      return mutate(addUrl, body).then(function (data) {
        if (!options || options.open !== false) {
          if (!root.classList.contains('is-open')) openDrawer();
        }
        return data;
      });
    },
    change: function (key, quantity) {
      return mutate(changeUrl, { id: key, quantity: quantity });
    },
    refresh: refresh,
    open: openDrawer,
    close: closeDrawer
  };

  // ---- Alterar quantidade / remover item ----
  function itemFor(key) {
    return root.querySelector('[data-cart-item][data-line-key="' + CSS.escape(key) + '"]');
  }

  function changeLine(key, quantity) {
    var item = itemFor(key);
    var input = item && item.querySelector('[data-cart-qty-input]');
    var previous = input ? input.value : null;
    var removing = quantity === 0;
    if (item) item.classList.add(removing ? 'is-removing' : 'is-updating');
    if (input && !removing) input.value = quantity; // cliques rápidos partem do valor desejado
    window.ErmosCart.change(key, quantity).catch(function () {
      // falha: restaura o item (mutate() já ressincroniza com o carrinho real; drawer continua aberto)
      var current = itemFor(key);
      if (current) current.classList.remove('is-removing', 'is-updating');
      if (current && input && previous !== null && current.contains(input)) input.value = previous;
    });
  }

  // ---- Quick add (recomendações) ----
  /* Brinde: o item entra como linha propria (_brinde) para poder ser contado
     e removido automaticamente se o produto que da direito sair do carrinho. */
  function giftProps(el) {
    return el && el.closest('[data-gift-pick]') ? { _brinde: 'sim' } : null;
  }

  function quickAdd(variantId, btn) {
    if (!variantId || (btn && btn.disabled)) return;
    var originalHtml = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.textContent = '···'; }
    var line = { id: variantId, quantity: 1 };
    var props = giftProps(btn);
    if (props) line.properties = props;
    window.ErmosCart.add([line])
      .catch(function () {})
      .then(function () {
        // o botão pode ter sido substituído pelo render; só restaura se ainda estiver no DOM
        if (btn && document.contains(btn)) { btn.disabled = false; if (originalHtml !== null) btn.innerHTML = originalHtml; }
      });
  }

  // ---- Delegação de eventos dentro do drawer (conteúdo é recriado via AJAX) ----
  root.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-cart-drawer-close]');
    if (closeBtn) {
      // Links (produto, "Continuar comprando") fecham o drawer E navegam normalmente
      // (a Page Transition global assume a navegação). Só o botão X cancela o default.
      if (!(closeBtn.tagName === 'A' && closeBtn.getAttribute('href'))) e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty-btn]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-line-key');
      var dir = qtyBtn.getAttribute('data-cart-qty-btn');
      var input = root.querySelector('[data-cart-qty-input][data-line-key="' + key + '"]');
      var current = input ? parseInt(input.value, 10) || 0 : 0;
      var next = dir === 'increase' ? current + 1 : current - 1;
      if (next < 0) return;
      changeLine(key, next);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-line-key'), 0);
      return;
    }

    var quickAddBtn = e.target.closest('[data-cart-quickadd]');
    if (quickAddBtn) {
      e.preventDefault();
      var directVariant = quickAddBtn.getAttribute('data-variant-id');
      if (directVariant) {
        quickAdd(directVariant, quickAddBtn);
        return;
      }
      var picker = quickAddBtn.closest('[data-recommend-card]');
      if (picker) {
        var panel = picker.querySelector('[data-recommend-sizes]');
        if (panel) panel.classList.toggle('is-open');
      }
      return;
    }

    var sizeOption = e.target.closest('[data-recommend-size]');
    if (sizeOption) {
      e.preventDefault();
      quickAdd(sizeOption.getAttribute('data-variant-id'), sizeOption);
      return;
    }

    var collapseBtn = e.target.closest('[data-cart-recommend-toggle]');
    if (collapseBtn) {
      e.preventDefault();
      var block = collapseBtn.closest('[data-cart-recommend-block]');
      if (block) {
        /* is-collapsed continua controlando a exibicao do track/scrollbar;
           aria-expanded e a fonte da verdade do estado (acessibilidade + CSS da seta). */
        var collapsed = block.classList.toggle('is-collapsed');
        collapseBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        collapseBtn.setAttribute('aria-label', collapsed ? 'Expandir recomendações' : 'Recolher recomendações');
      }
      return;
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 0) val = 0;
    changeLine(input.getAttribute('data-line-key'), val);
  });

  // ---- Recomendações: busca assíncrona (mesmo padrão de related-products.liquid) ----
  function initRecommendations() {
    var block = root.querySelector('[data-cart-recommend][data-url]');
    if (!block || block.dataset.loaded === 'true') return;
    block.dataset.loaded = 'true';
    fetch(block.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-recommend-list]');
        var list = block.querySelector('[data-cart-recommend-list]');
        if (fresh && list && fresh.children.length) {
          list.innerHTML = fresh.innerHTML;
          block.hidden = false;
          initCarousel();
        }
      })
      .catch(function () {});
  }

  // ---- Carrossel horizontal (drag no desktop, touch nativo no mobile) — isolado do carrossel da Home ----
  // mousemove/mouseup ficam UMA vez em window (antes eram adicionados a cada trilho novo
  // e nunca removidos); o trilho ativo é guardado em dragTrack.
  var drag = { track: null, startX: 0, startScroll: 0, moved: false };
  window.addEventListener('mousemove', function (e) {
    if (!drag.track) return;
    var dx = e.pageX - drag.startX;
    if (Math.abs(dx) > 6) drag.moved = true;
    drag.track.scrollLeft = drag.startScroll - dx;
  });
  window.addEventListener('mouseup', function () {
    var track = drag.track;
    if (!track) return;
    drag.track = null;
    track.classList.remove('is-dragging');
    if (drag.moved) {
      track.__justDragged = true;
      setTimeout(function () { track.__justDragged = false; }, 50);
    }
  });

  function initCarousel() {
    var tracks = root.querySelectorAll('[data-cart-carousel]:not([data-drag-init])');
    tracks.forEach(function (track) {
      track.setAttribute('data-drag-init', 'true');
      track.addEventListener('mousedown', function (e) {
        drag.track = track; drag.moved = false;
        drag.startX = e.pageX; drag.startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('click', function (e) {
        if (track.__justDragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  initRecommendations();
  initCarousel();

  // ---- Forms de produto nativos marcados com data-ermos-ajax-cart (ex.: Featured Showcase):
  //      mesmo fluxo do drawer em vez de navegar para /cart. Sem JS, o form segue nativo. ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ermos-ajax-cart]') || e.defaultPrevented) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    if (btn && btn.disabled) return;
    if (btn) btn.disabled = true;
    window.ErmosCart.add(new FormData(form))
      .catch(function () {})
      .then(function () { if (btn) btn.disabled = false; });
  });

  // ---- Ponte legada: qualquer módulo pode pedir ressincronização + abrir o drawer ----
  document.addEventListener('ermos:cart:refresh', function () {
    refresh().then(openDrawer).catch(function () {});
  });

  // ---- Brinde: confere o carrinho renderizado pelo servidor (ex.: carrinho antigo
  //      com brinde mas sem a peça que dá direito) ----
  reconcileGift();

  // ---- Voltar pelo histórico (bfcache): a página congelada pode ter um carrinho antigo ----
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh().catch(function () {});
  });
})();
